import { render } from "./NegativeLot.vue?vue&type=template&id=2235d838"
import script from "./NegativeLot.vue?vue&type=script&lang=js"
export * from "./NegativeLot.vue?vue&type=script&lang=js"
script.render = render

export default script